import { SocialLabels } from '../../types';

export interface Social {
  web: string;
  twitter: string;
  facebook: string;
  instagram: string;
  wikipedia: string;
  youtube: string;
}

export const mapResponseToSocial = (socials: Record<string, string>) => {
  const social: Social = {} as Social;
  if (socials) {
    social.facebook = socials.facebookId ? `https://www.facebook.com/${socials.facebookId}` : '';
    social.instagram = socials.instagramId ? `https://www.instagram.com/${socials.instagramId}` : '';
    social.twitter = socials.twitterId ? `https://twitter.com/${socials.twitterId}` : '';
    social.wikipedia = socials.wikipediaId ? `https://en.wikipedia.org/wiki/${socials.wikipediaId}` : '';
    social.youtube = socials.youtubeChannelId ? `https://www.youtube.com/user/${socials.youtubeChannelId}` : '';
    social.web = socials.web ? socials.web : '';
  } else {
    return {};
  }

  return social;
};

export const getSocialKeyByValue = (object: Record<string, string>, value: string) => {
  for (const prop in object) {
    // eslint-disable-next-line no-prototype-builtins
    if (object.hasOwnProperty(prop)) {
      if (object[prop] === value) return prop;
    }
  }

  return '';
};

export const returnBuiltSocialData = (socials: Record<string, string>, social: string) => {
  if (socials[social]) {
    const socialLink = socials[social].replace(/\/$/, '');

    const socialLinkType = getSocialKeyByValue(socials, socials[social]);
    const lastPartOfLink =
      socialLinkType === SocialLabels.WEB ? socialLink : socialLink.substring(socialLink.lastIndexOf('/') + 1, socialLink.length);

    return buildSocialUrl(socialLinkType, lastPartOfLink);
  }

  return '';
};

export const buildSocialUrl = (type: string, identifier: string) => {
  if (identifier) {
    let url = '';
    switch (type) {
      case SocialLabels.FACEBOOK:
        url = 'https://www.facebook.com/' + identifier;
        break;
      case SocialLabels.INSTAGRAM:
        url = 'https://www.instagram.com/' + identifier;
        break;
      case SocialLabels.TWITTER:
        url = 'https://twitter.com/' + identifier;
        break;
      case SocialLabels.WEB:
        url = identifier;
        break;
      case SocialLabels.WIKIPEDIA:
        url = 'https://en.wikipedia.org/wiki/' + identifier;
        break;
      case SocialLabels.YOUTUBE:
        url = 'https://www.youtube.com/' + identifier;
    }
    return url;
  }
  return '';
};
